export default __webpack_public_path__ + "static/media/kinetic-logo.b9670197.png";